import React, { useCallback, useState, useEffect } from "react";
import { Page, Toast } from "@shopify/polaris";
import { useSelector, useDispatch } from "react-redux";
import { getAllPriceUpdate } from "../redux/priceUpdate/slice";
import { createUserOnboardingAsync, getUserOnboardingAsync } from "../redux/userOnboarding";
import { getAllUserOnboarding } from "../redux/userOnboarding/slice";
import SetupGuide from "../components/app-overview/SetupGuide";
import { ONBOARDING__STEPS } from "../utils";

const AppOverviewPage = () => {
    const dispatch = useDispatch();
    const { isMetafieldDefinitionLoading, isSaving } = useSelector(getAllPriceUpdate);
    const { userOnboardingData, isOnboardingLoading } = useSelector(getAllUserOnboarding);
    const [items, setItems] = useState(ONBOARDING__STEPS);
    const [expanded, setExpanded] = useState(items.findIndex((item) => !item.complete));
    const [active, setActive] = useState(false);
    const [toastContent, setToastContent] = useState('');

    useEffect(() => {
        if (userOnboardingData?.steps) {
            const steps = items.map((step) => ({
                ...step,
                complete: userOnboardingData?.steps.find((s) => s.step === step.id)?.completed
            }));
            setItems(steps);
            if (steps.every((step) => step.complete)) {
                setExpanded(-1);
            } else {
                const firstIncompleteStepIndex = steps.findIndex((step) => !step.complete);
                setExpanded(firstIncompleteStepIndex);
            }
        }
    }, [userOnboardingData]);

    const toggleActive = useCallback((content) => {
        setActive((active) => !active)
        setToastContent(content);
    }, []);

    const toastMarkup = active ? (
        <Toast duration={2000} content={toastContent} onDismiss={toggleActive} />
    ) : null;

    const onStepComplete = async (id) => {
        try {
            await new Promise((res) =>
                setTimeout(() => {
                    res();
                }, [1000])
            );
            setItems((prev) => prev.map((item) => (item.id === id ? { ...item, complete: !item.complete } : item)));
            const nextStepIndex = id + 1;
            if (nextStepIndex < items.length) {
                setExpanded(nextStepIndex);
            } else {
                setExpanded(-1);
            }
            const steps = userOnboardingData?.steps?.map((item) => ({
                ...item,
                completed: item.step === id ? true : item.completed,
            }));
            handleCompleteOnboarding(steps, false);
        } catch (e) {
            console.error(e);
        }
    };

    const handleCompleteOnboarding = async (steps, isOnboardingCompleted) => {
        dispatch(createUserOnboardingAsync({
            payload: {
                steps: isOnboardingCompleted ? userOnboardingData?.steps : steps,
                isOnboardingCompleted: isOnboardingCompleted,
            },
            callback: (success) => {
                if (success) {
                    handleGetOnboarding();
                }
            },
        }));
    };

    const handleGetOnboarding = async () => {
        dispatch(getUserOnboardingAsync());
    };

    return (
        <Page>
            <div className="max-w-[60rem] m-auto">
                <SetupGuide
                    onDismiss={() => {
                        setItems(ONBOARDING__STEPS);
                    }}
                    onStepComplete={onStepComplete}
                    items={items}
                    isLoading={isSaving || isMetafieldDefinitionLoading}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    showToast={toggleActive}
                    handleCompleteOnboarding={handleCompleteOnboarding}
                    isOnboardingLoading={isOnboardingLoading}
                />
            </div>
            {toastMarkup}
        </Page>
    );
};

export default AppOverviewPage;
